import { api as apiService, ApiService } from './api'
import { baseURL } from 'settings'

export interface IJobParams {
  depotId?: number
  executionDate: string
  status?: string
  createdById?: string
}

export interface IOptimizationJob {
  id: number
  durationSeconds: number
  isTerminated: boolean
  depotId: number
  depotName: string
  status: string
  executionDate: string
  createdAt: string
  updatedAt: string
  terminatedAt: string | null
  createdById: string | null
  createdByName: string | null
  hasAlerted: boolean
}

export interface IJobResponse {
  [depotName: string]: IOptimizationJob[]
}

class RouteOptimizationService {
  constructor(
    private readonly api: ApiService,
    private readonly baseURL: string,
  ) { }

  public getJobs = async (params: IJobParams): Promise<IJobResponse> => {
    return await this.api.get(`${this.baseURL}/v1/route-optimization/jobs`, { params })
  }
}

export const routeOptimizationService = new RouteOptimizationService(apiService, baseURL)
